import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Lock, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
export function Login() {
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as {
    from?: string;
  })?.from || '/account';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const result = login(email, password);
    if (!result.success) {
      setError(result.error || 'Login failed.');
      return;
    }
    toast.success('Welcome back!');
    navigate(redirectTo);
  };
  return <div className="min-h-[80vh] bg-gray-50 flex items-center justify-center py-12 px-4" data-id="element-566">
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 max-w-md w-full" data-id="element-567">
        <div className="text-center mb-6" data-id="element-568">
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-569">
            Welcome back
          </h1>
          <p className="text-gray-500 text-sm" data-id="element-570">
            Sign in to your account to manage orders and addresses.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-571">
          <div data-id="element-572">
            <label htmlFor="login-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-573">
              Email
            </label>
            <div className="relative" data-id="element-574">
              <Mail className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-575" />
              <input id="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-576" />
            </div>
          </div>

          <div data-id="element-577">
            <label htmlFor="login-password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-578">
              Password
            </label>
            <div className="relative" data-id="element-579">
              <Lock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-580" />
              <input id="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-581" />
            </div>
          </div>

          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3" data-id="element-582">
              {error}
            </div>}

          <button type="submit" className="w-full bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 transition-colors flex items-center justify-center gap-2" data-id="element-583">
            Sign In <ArrowRight className="w-4 h-4" data-id="element-584" />
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-gray-100 text-center text-sm text-gray-600" data-id="element-585">
          Don't have an account?{' '}
          <Link to="/register" state={{
          from: redirectTo
        }} className="text-red-600 font-medium hover:underline" data-id="element-586">
            Create one
          </Link>
        </div>
      </div>
    </div>;
}